import { Pressable } from 'react-native';
import { BodySmallRegular, Icon, RotateCcwIcon } from 'smoothie';

const NewChatButton = ({ onPress }: { onPress: () => void }) => (
    <Pressable
        onPress={onPress}
        style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4,
            paddingHorizontal: 12,
            paddingVertical: 6,
        }}
    >
        <Icon icon={RotateCcwIcon} size={14} stringColor="#666" />
        <BodySmallRegular color="$gray1100">Start over</BodySmallRegular>
    </Pressable>
);

export default NewChatButton;
